import { render, staticRenderFns } from "./SelecaoPeriodo.vue?vue&type=template&id=fdf73c00&"
import script from "./SelecaoPeriodo.vue?vue&type=script&lang=js&"
export * from "./SelecaoPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports